/**
 * Parses API date/time values. Server stores UTC; Newtonsoft often serializes
 * DateTime without a timezone suffix, which browsers treat as local time.
 */
export function parseApiDateTime(value: string | undefined | null): Date {
  if (value == null || value === '') {
    return new Date(NaN);
  }

  const raw = String(value).trim();

  const msDateMatch = /\/Date\((-?\d+)(?:[+-]\d{4})?\)\//.exec(raw);
  if (msDateMatch) {
    return new Date(Number(msDateMatch[1]));
  }

  if (/[zZ]$/.test(raw) || /[+-]\d{2}:\d{2}$/.test(raw)) {
    return new Date(raw);
  }

  // Bare ISO datetime from API — treat as UTC
  return new Date(`${raw}Z`);
}
